import client from '../httpClient';

// 【mokuhyoMst004】キマリス目標一括更新
const updateAllKimarisTarget = (params) => {
  return client.put('/keymalis-target-settings/all/', JSON.stringify(params));
};

export default updateAllKimarisTarget;
